// Global Instructions Rule Applied!
//
// Inline text cell for the Pipelines config tables. Commits on blur or Enter,
// and only when changed, so in-table editing doesn't write per keystroke.
import React, { useEffect, useState } from 'react'
import { Input } from 'antd'

interface InlineTextFieldProps {
  value: string
  placeholder?: string
  maxLength?: number
  onCommit: (value: string) => void
}

export default function InlineTextField({
  value,
  placeholder,
  maxLength = 120,
  onCommit
}: InlineTextFieldProps): React.ReactElement {
  const [v, setV] = useState(value)
  useEffect(() => {
    setV(value)
  }, [value])

  const commit = (): void => {
    if (v !== value) onCommit(v)
  }

  return (
    <Input
      size="small"
      placeholder={placeholder}
      maxLength={maxLength}
      value={v}
      onChange={(e) => setV(e.target.value)}
      onBlur={commit}
      onPressEnter={commit}
    />
  )
}
